import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Testimonials from "../pages/testimonials/page";
import Credentials from "../pages/credentials/page";
import Gallery from "../pages/gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/credentials",
    element: <Credentials />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;